module.exports = __webpack_public_path__ + "static/media/img-mazatlan.62c88c89.jpg";